import * as yup from "yup";
import { useFormik } from "formik";
import { CustomerBusinessUnitData } from "./customer-model";

/**
 * Manages form data for customer business unit data step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useCustomerBusinessUnitFormik(
  onNext: (data: CustomerBusinessUnitData) => void
) {
  const validationSchema = yup.object().shape({
    businessUnit: yup.array().of(yup.string()),
    soldToShipTo: yup.string(),
  });

  const formik = useFormik<CustomerBusinessUnitData>({
    initialValues: {
      businessUnits: [],
      soldToShipTo: "",
    },
    validationSchema: validationSchema,
    // use handleSubmission instead
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
